export const LOGIN_ROUTE = '/login';
export const RESET_PASSWORD_ROUTE = '/reset-password';
export const DASHBOARD_ROUTE = '/';

export const ADMINS_ROUTE = '/admins';
export const NEW_ADMIN_ROUTE = '/admins/new';
export const RESETPASSWORD_ADMIN_ROUTE = '/admins/resetPassword/:id';
export const EDIT_ADMIN_ROUTE = '/admins/edit/:id';

export const INSPECTORS_ROUTE = '/inspectors';
export const NEW_INSPECTOR_ROUTE = '/inspectors/new';
export const RESETPASSWORD_INSPECTOR_ROUTE = '/inspectors/resetPassword/:id';
export const EDIT_INSPECTOR_ROUTE = '/inspector/updateUser/:id';

export const SUPERVISORS_ROUTE = '/supervisors';
export const NEW_SUPERVISOR_ROUTE = '/supervisors/new';
export const RESETPASSWORD_SUPERVISOR_ROUTE = '/supervisors/resetPassword/:id';
export const EDIT_SUPERVISOR_ROUTE = '/supervisors/edit/:id';


export const INSPECTORSAPPLICATIONS_ROUTE = '/inspectionList';
export const NEW_INSPECTIONAPPLICATIONS_ROUTE = '/inspectionList/new';
export const INSPECTORSAPPLICATIONS_DETAIL_ROUTE = '/inspectionList/detail/:id';
